// extracted by mini-css-extract-plugin
export default {"container":"Profile_container__HmgJd","wrapper":"Profile_wrapper__U5Rhj","imgWrapper":"Profile_imgWrapper__goFFO","imgData":"Profile_imgData__Nd0ZW"};